export default "__VITE_ASSET__ecc5dfa9__"